import { IStore } from 'redux/root';
import { IUser } from 'stubs/graphql/user';

export const getLoggedIn = (store: IStore): boolean => store.account.loggedIn;

export const getMe = (store: IStore): IUser => store.account.me.node;
